export default __webpack_public_path__ + "static/media/article3.bf8733f7.png";